module.exports = __webpack_public_path__ + "img/Old-Obi-Wan-icon.ae7c497f.png";